import styled from 'styled-components';

import Dialog from '@mui/material/Dialog';

const StyledModal = styled(Dialog)`
  .MuiPaper-root {
    padding: 24px;
    border-radius: 8px;
    border: 0px solid ${({ theme }) => theme.palette.grey[200]};
    background: ${({ theme }) => theme.palette.common.white};
    box-shadow: ${({ theme }) => theme.shadows.card};
  }
`;

export const SimpleModal = styled(StyledModal)`
  .MuiPaper-root {
    max-width: 360px;
    align-items: center;
  }
`;

export const StyledModalTitle = styled.h2`
  font-size: 20px;
  letter-spacing: 0.15px;
  color: ${({ theme }) => theme.palette.text.primary};
  margin: 12px 0 0;
  font-weight: 500;
  text-align: center;
  text-transform: capitalize;
`;
